import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Icon, Loader, Table } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  Center,
  Button
} from "./styles";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { datePattern } from '../../../utils/Utils';

const LogsUser = () => {
  const [logs, setLogs] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = {
      search
    }
    api.get('/user-logs', params).then(res => {
      setLogs(res.data.items)
    })
  }, [search])

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Logs de Ações</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Procurar por nome..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Icon name="search icon" />
          </ContainerInputSearch>

          <Table stackable>
            <Table.Header>
              <Table.HeaderCell>
                <Center>Aluno</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>discrição - método</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>url (id do pedido)</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>error</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>data</Center>
              </Table.HeaderCell>
            </Table.Header>

            <Table.Body>
              {loading ? <Loader active={loading} /> :
                logs && logs.length !== 0 ? logs.map(log => (
                  <Table.Row>
                    <Table.Cell >
                      <Center>{log.name}
                        <Button
                          href={`/admin/alunos/detalhes/${log.id_pessoa}`}
                          target="_blank"
                        >
                          Ver informações
                        </Button>
                      </Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{log.description}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{log.url}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{log.error && log.error.length !== 0 && log.error.map(err => err)}</Center>
                    </Table.Cell>
                    <Table.Cell >
                      <Center>{datePattern(log.created_at)}</Center>
                    </Table.Cell>
                  </Table.Row>)) : <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan='7'>
                      <p>Nenhuma log encontrado</p>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>}
            </Table.Body>
          </Table>

        </Content>

      </Container>
    </>
  );
};

export default withRouter(LogsUser);
